module.exports = __webpack_public_path__ + "assets/d202a10f60326363605b0fb393027db8.mp3";